import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { DishesContext, IDishesContext } from '../../../../../dishesState/dishesContext';
import style from './DropdownMenu.module.scss';

const DropdownMenu: React.FC = () => {
	const { setSortBy, sortBy } = useContext<IDishesContext>(DishesContext);

	return (
		<div className={style.container} data-test="DropdownMenu">
			<div className={style.resetWrapper}>
				<span className={style.resetBtn} onClick={() => setSortBy('')}>
					<Text translationNameSpace="listing" translationKey="resetButton" asFragment={true} />
				</span>
			</div>

			<div className={style.item}>
				<div className={style.headingWrapper}>
					<Text
						translationNameSpace="listing"
						translationKey="sortByNameLabel"
						theme="neutralLight"
						size="s"
					/>
				</div>
				<label className={style.sortingControl}>
					<Text translationNameSpace="listing" translationKey="sortByNameA-Z" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('NameA-Z')}
						checked={sortBy === 'NameA-Z'}
						name="assignmentSort"
					/>
				</label>
				<label className={style.sortingControl}>
					<Text translationNameSpace="listing" translationKey="sortByNameZ-A" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('NameZ-A')}
						checked={sortBy === 'NameZ-A'}
						name="assignmentSort"
					/>
				</label>

				<div className={style.headingWrapper}>
					<Text
						translationNameSpace="listing"
						translationKey="sortByPriceLabel"
						theme="neutralLight"
						size="s"
					/>
				</div>
				<label className={style.sortingControl}>
					<Text translationNameSpace="listing" translationKey="sortByPrice1-10" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('Price1-10')}
						checked={sortBy === 'Price1-10'}
						name="assignmentSort"
					/>
				</label>
				<label className={style.sortingControl}>
					<Text translationNameSpace="listing" translationKey="sortByPrice10-1" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('Price10-1')}
						checked={sortBy === 'Price10-1'}
						name="assignmentSort"
					/>
				</label>
			</div>
		</div>
	);
};

export default DropdownMenu;
